export const state = {
  user: { id: '001', name: 'PopsonJr' },
}
